import React from "react";
import BaseButton from "@reusables/BaseButton";
import BaseModal from "@reusables/Modals/BaseModal";

interface RoleDemotionConfirmationModalProps {
    isOpen: boolean;
    isLoading?: boolean;
    title: string;
    message?: string;
    cancelText: string;
    confirmText: string;
    onCancel: () => void;
    onConfirm: () => void;
}

export default function RoleDemotionConfirmationModal({
    isOpen,
    isLoading,
    title,
    message,
    cancelText,
    confirmText,
    onCancel,
    onConfirm
}: RoleDemotionConfirmationModalProps) {
    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onCancel}
            width={700}
            padding="56px"
            isLoading={isLoading}
        >
            <div className="space-y-[32px]">
                <div className="text-xl font-semibold text-center text-accent">{title}</div>
                <div className="text-center text-accent">{message}</div>
                <div className="grid grid-cols-2 gap-[16px]">
                    <BaseButton
                        text={cancelText}
                        size="md"
                        primaryOutlined
                        type="button"
                        onClick={onCancel}
                    />
                    <BaseButton
                        text={confirmText}
                        size="md"
                        type="button"
                        color="#E25C5C"
                        onClick={onConfirm}
                    />
                </div>
            </div>
        </BaseModal>
    );
}
